module.exports = __webpack_public_path__ + "img/stPay2.6955ddc4.jpg";